module.exports = __webpack_public_path__ + "static/img/male-2.6458a91d.png";